import React, { useEffect, useState } from 'react';
import { Typography, Box, Paper } from '@mui/material';
import Loader from '../Loader';

const messages = [
  'Confirming purchase...',
  'Fetching your credentials...',
  'Almost there...',
  'Preparing your dashboard...',
  'Just a second more...',
  'Hang tight, good things take time!',
];

const LoadingPage = ({ setError }) => {
  const [messageIndex, setMessageIndex] = useState(0);

  useEffect(() => {
    let timeout;
    const interval = setInterval(() => {
      setMessageIndex(prev => {
        if (prev >= messages.length - 1) {
          clearInterval(interval); // Stop the interval
          timeout = setTimeout(() => setError(true), 10000);
          return prev; // Don't change the index anymore
        }
        return prev + 1;
      });
    }, 3000); // change message every 3 seconds

    return () => {
      clearInterval(interval);
      clearTimeout(timeout);
    };
  }, []);

  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        bgcolor: '#f9fafb',
        padding: 2,
      }}
    >
      <Paper
        elevation={3}
        sx={{
          padding: 4,
          maxWidth: 400,
          width: '100%',
          textAlign: 'center',
          borderRadius: 3,
        }}
      >
        <Loader />
        <Typography
          variant="h6"
          mt={3}
          sx={{ fontFamily: 'Inter, Segoe UI, Roboto, Helvetica Neue, Arial, sans-serif' }}
        >
          {messages[messageIndex]}
        </Typography>
      </Paper>
    </Box>
  );
};

export default LoadingPage;
